import React, { useCallback } from "react";
import Modal from "@ui/Modal";
import { useLockDashboardCallback, useUnlockDashboardCallback } from "../../../hook/action/lock";
import ModalForm from "@ui/Modal/Form";
import AdditionnalMessage from "@ui/AdditionnalMessage";
import Text from "@ui/Text";
import t from "../../../../../../i18n";
import { useTranslations } from "../../../../../../api/useTranslations";
import { useNavigate } from "react-router";
import { toPath } from "../../../../../../router/helpers/path";

export function UnlockDashboardModal({
  projectId,
  dashboardId,
  opened,
  close,
}: {
  projectId: string;
  dashboardId: string;
  opened: boolean;
  close: () => void;
}) {
  const translations = useTranslations();
  const navigate = useNavigate();
  const unlockDashboard = useUnlockDashboardCallback(projectId);
  const lockDashboard = useLockDashboardCallback(projectId);
  const unlock = useCallback(async () => {
    const unlocked = await unlockDashboard(dashboardId);
    if (!unlocked) return false;
    const locked = await lockDashboard(dashboardId);
    if (!locked) return false;
    void navigate(
      toPath("/projects/:projectId/dashboards/:dashboardId/edit", {
        projectId,
        dashboardId,
      }),
    );
    return true;
  }, [dashboardId, lockDashboard, unlockDashboard, navigate, projectId]);
  return (
    <Modal
      isOpen={opened}
      title={t("project.dashboard.transaction.unlock.title")}
      onRequestClose={close}
      size="l"
    >
      <ModalForm
        onSubmit={unlock}
        onRequestClose={close}
        okButtonName={t("project.dashboard.transaction.unlock.action")}
        okButtonVariant="destructive"
      >
        <Text>{t("project.dashboard.transaction.unlock.text", translations)}</Text>
        <AdditionnalMessage
          status="WARNING"
          text={t("project.dashboard.transaction.unlock.warning")}
        />
      </ModalForm>
    </Modal>
  );
}
